(function($) {

    'use strict';    

	var init = function() {

        if($('body.home').length > 0 || $('body.page-template-template-custom-homepage').length > 0) {
            
            initSwiperNews();

            if($('body').hasClass('home')) {
                triggerCountUp();
            }

            videoPlayer();

            bullColor();

            togglePhilo();

            tabsForm();

            $('.fp-form__linkAll a').click(function() {
                $('.fp-form__hidden').submit()
            });

        }

    };
    
    var initSwiperNews = function() {

        var isFirefox = !(window.mozInnerScreenX == null);

        if(isFirefox == false) {
            var swiper = new Swiper('.fp-news__swiper-container', {
                observer: true,
                observeParents: true,
                updateOnWindowResize: true,
                centeredSlides: true,
                slidesPerView: 1.25,
                spaceBetween: 25,
                effect: 'coverflow',
                coverflowEffect: {
                    rotate: 15,
                    slideShadows: false,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                        initialSlide: 1,
                    },
                    1200: {
                        spaceBetween: 50,
                        slidesPerView: 2.5,
                        initialSlide: 1,
                    },
                    1440: {
                        spaceBetween: 80,
                        slidesPerView: 2.5,
                        initialSlide: 1,
                    }
                }
            });
    
            swiper.on('sliderMove', function() {
                $('.blend').each(function() {
                    $(this).addClass('touch');
                });
            });
            swiper.on('transitionEnd', function() {
                $('.blend').each(function() {
                    $(this).removeClass('touch');
                });
            });
        } else {
            var swiper = new Swiper('.fp-news__swiper-container', {
                observer: true,
                observeParents: true,
                updateOnWindowResize: true,
                centeredSlides: true,
                slidesPerView: 1.25,
                spaceBetween: 25,
                breakpoints: {
                    768: {
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                        initialSlide: 1,
                    },
                    1200: {
                        spaceBetween: 50,
                        slidesPerView: 2.5,
                        initialSlide: 1,
                    },
                    1440: {
                        spaceBetween: 80,
                        slidesPerView: 2.5,
                        initialSlide: 1,
                    }
                }
            })
        }
    }

    var triggerCountUp = function() {

        var isTriggered = false;

        $(window).scroll(function() {
            if(isTriggered == false) {
                if(($(window).scrollTop() > $('.fp-keys').offset().top - $(window).height() / 2) && ($(window).scrollTop() < $('.fp-keys').offset().top + $(window).height() / 2)) {

                    countUp();
    
                    isTriggered = true;
    
                }
            }
        });
    }

    var countUp = function() {
        
        $('.count').each(function() {
            var number = $(this).data('number')

            $(this).countTo({
                from: 0,
                to: number,
                speed: 2000,
                refreshInterval: 10
            });
        });
    }

    var videoPlayer = function() {

        $('.fp-exp__cover').click(function() {
            $('.fp-exp__cover').addClass('fp-exp__cover--none');
            $('.fp-exp__video video').get(0).play()
            $('.fp-exp__video video').prop('controls', true)
            $('.fp-exp__video video').get(0).volume = 0.1;
            $('.fp-exp__bull').addClass('alt')
        })

    }

    var bullColor = function() {
        var bull = $('.fp-exp__bull')
        var i = 0

        bull.click(function() {
            if(i < 2) {
                i++
            } else {
                i = 0
            }
            switch(i) {
                case 0:
                    $(this).removeClass('fp-exp__bull--tertiary')
                    $(this).addClass('fp-exp__bull--primary')
                    break
                case 1:
                    $(this).removeClass('fp-exp__bull--primary')
                    $(this).addClass('fp-exp__bull--secondary')
                    break
                case 2:
                    $(this).removeClass('fp-exp__bull--secondary')
                    $(this).addClass('fp-exp__bull--tertiary')
                    break
            }
        })
    }

    var togglePhilo = function() {

        var button = $('.fp-philo__item__link')

        var time

        $(window).resize(function() {
            if($(window).width() < 992) {
                time = 300
            } else {
                time = 0
            }
            return time
        })

        button.each(function() {
            if($(this).parent('.fp-philo__item').hasClass('open')) {
                $(this).siblings('.fp-philo__item__desc').slideDown(0)
            }
        })

        button.click(function() {
            var img = $('#' + $(this).data('target'))
            var parent = $(this).parent('.fp-philo__item')
            if(!parent.hasClass('open') && !img.hasClass('show')) {
                $('.fp-philo__item').removeClass('open')
                $('.fp-philo__item__desc').slideUp(time)
                parent.addClass('open')
                $('.fp-philo__img').removeClass('show')
                $(this).siblings('.fp-philo__item__desc').slideDown(300)
                img.addClass('show')
            }
        })
    }

    var tabsForm = function() {

        var button = $('.fp-form__nav__item button')

        button.click(function() {
            var tab = $('#' + $(this).data('term'))
            if(!tab.hasClass('active')) {
                button.removeClass('active')
                $('.fp-form__list').removeClass('active')
                $(this).addClass('active')
                tab.addClass('active')
            }
        })

    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
